var map = {
	"./facebook-icon.svg": 933,
	"./facebook.svg": 934,
	"./instagram-icon.svg": 935,
	"./instagram.svg": 936,
	"./linkedin.svg": 937,
	"./pinterest.svg": 938,
	"./sprite.svg": 639,
	"./telegram.svg": 939,
	"./tiktok-icon.svg": 940,
	"./tiktok.svg": 941,
	"./twiter.svg": 942,
	"./twitter.svg": 943,
	"./viber.svg": 944,
	"./wats-up-icn.svg": 945,
	"./youtube.svg": 946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 932;